<template>
  <span v-if="isWithdrawn" class="float-end">{{ $t('purchase.cancelModal.cancelRequestAlreadySent') }}</span>
  <a class="btn btn-default" v-bind="$attrs" @click="open" v-else-if="canCancel">
    <slot>{{ $t('purchase.history.labels.cancel') }}</slot>
  </a>

  <BModal v-model="isModalVisible" :title="$t('purchase.cancelModal.title')" no-close-on-backdrop>
    <p v-if="isSuccess">{{ $t('purchase.cancelModal.successMessage') }}</p>

    <ValidationGroup v-else alwaysSubmit @submit="submit" ref="form">
      <p>{{ $t('purchase.cancelModal.body') }}</p>

      <div class="mb-3">
        <ValidationField highlight required email :value="details.email">
          <template v-slot:default>
            <label>{{ $t('purchase.cancelModal.emailLabel') }}</label>
            <input type="email" class="form-control" v-model="details.email" name="email">
          </template>
        </ValidationField>
      </div>

      <div class="mb-3">
        <ValidationField highlight required :value="details.iban">
          <template v-slot:default>
            <label>{{ $t('purchase.cancelModal.ibanLabel') }}</label>
            <input type="text" class="form-control" v-model="details.iban" name="iban">
          </template>
        </ValidationField>
      </div>

      <div class="mb-3">
        <ValidationField highlight required :value="details.accountHolder">
          <template v-slot:default>
            <label>{{ $t('purchase.cancelModal.accountHolderLabel') }}</label>
            <input type="text" class="form-control" v-model="details.accountHolder" name="accountHolder">
          </template>
        </ValidationField>
      </div>

      <div class="alert alert-danger" v-if="showMissingRequired">{{ $t('purchase.cancelModal.missingRequired') }}</div>
    </ValidationGroup>

    <template v-slot:footer>
      <button v-if="!isSuccess" type="button" class="btn btn-lg btn-success" name="agree" @click="$refs.form.submit()">
        {{ $t('purchase.cancelModal.confirm') }}
      </button>
      <button v-if="!isSuccess" type="button" class="btn btn-lg btn-secondary" name="cancel" @click="close">
        {{ $t('purchase.cancelModal.cancel') }}
      </button>
      <button v-if="isSuccess" type="button" class="btn btn-lg btn-secondary" name="cancel" @click="close">
        {{ $t('close') }}
      </button>
    </template>
  </BModal>
</template>

<script>
import { mapActions } from 'vuex';
import { BModal } from 'bootstrap-vue-next';
import ValidationField from './ValidationField';
import ValidationGroup from './ValidationGroup';

const MS_IN_DAY = 24 * 60 * 60 * 1000;
const CANCEL_WINDOW_DAYS = 14;

export default {
  components: { BModal, ValidationField, ValidationGroup },
  inheritAttrs: false,
  props: ['item'],
  emits: ['agree'],
  data: () => ({
    isModalVisible: false,
    isSuccess: false,
    showMissingRequired: false,
    details: {
      email: '',
      iban: '',
      accountHolder: '',
    },
  }),
  computed: {
    isWithdrawn() {
      return !!this.item.withdrawnAt;
    },
    canCancel() {
      if (this.isWithdrawn || !this.item.date) {
        return false;
      }

      const daysSincePurchase = (Date.now() - new Date(this.item.date).getTime()) / MS_IN_DAY;

      return daysSincePurchase <= CANCEL_WINDOW_DAYS;
    },
  },
  methods: {
    ...mapActions('purchase', ['withdrawPurchase']),
    open() {
      this.isSuccess = false;
      this.showMissingRequired = false;
      this.isModalVisible = true;
    },
    close() {
      this.isModalVisible = false;
    },
    submit({ valid }) {
      this.showMissingRequired = !valid;

      if (!valid) {
        return;
      }

      // Centralized here since every page using this button needs the exact same action.
      this.withdrawPurchase({
        purchaseId: this.item.purchaseId,
        email: this.details.email,
        iban: this.details.iban,
        accountOwnerName: this.details.accountHolder,
      }).then(() => {
        this.$emit('agree', { item: this.item, ...this.details });
        this.isSuccess = true;
      });
    },
  },
};
</script>
